import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TextAreaField = React.forwardRef<HTMLTextAreaElement, any>((props, ref) => {
  const { infoText, ...restProps } = props;
  
  const getInfoText = () => {
    if (typeof infoText === "string") return infoText;
    return "";
  };

  const finalInfoText = getInfoText();

  return (
    <>
      <div className="form-floating position-relative">
        <textarea
          ref={ref}
          className={`form-control ${props.className || ""}`}
          placeholder={props.placeholder || "Enter text here"}
          style={{ height: props.height || '100px', ...props.style }}
          {...restProps}
        />
        <label htmlFor={props.id || "floatingTextArea"}>
          {props?.placeholder}
          {finalInfoText && !props.disabled && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${props.name}`}>{finalInfoText}</Tooltip>}
            >
              <a className="ms-1 align-self-center">
                <img className=" pe-auto" 
                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
              </a>
            </OverlayTrigger>
          )}
        </label>
      </div>
    </>
  );
});

export default TextAreaField;
